import React from "react";
import WebsocketEventer from "../../utils/websockets/WebsocketEventer";

export const WebSocketContext = React.createContext<
  WebsocketEventer | undefined
>(undefined);
